/**
 * Medbook
 * Medbook api
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { UserTrainingPlanUserCourseLevelsInner } from './userTrainingPlanUserCourseLevelsInner';
import { TrainingPlanDomain } from './trainingPlanDomain';
import { UserTrainingPlanUserCourseSupervisorsInner } from './userTrainingPlanUserCourseSupervisorsInner';
import { CourseModule } from './courseModule';
import { UserTrainingPlanUserCourseTimeRegistration } from './userTrainingPlanUserCourseTimeRegistration';


/**
 * 
 */
export interface PartialUserTrainingPlanUserCourse { 
    /**
     * 
     */
    id?: number;
    /**
     * 
     */
    refcode?: string;
    /**
     * 
     */
    level?: string;
    /**
     * 
     */
    levelSupervisor?: string;
    /**
     * 
     */
    levels?: Array<UserTrainingPlanUserCourseLevelsInner>;
    /**
     * 
     */
    skills?: string;
    /**
     * 
     */
    requirements?: string;
    /**
     * 
     */
    methods?: string;
    /**
     * 
     */
    qualified?: boolean;
    /**
     * 
     */
    courseEditable?: boolean;
    /**
     * 
     */
    courseId?: number;
    /**
     * 
     */
    periodId?: number;
    /**
     * 
     */
    startDate?: string;
    /**
     * 
     */
    endDate?: string;
    /**
     * 
     */
    hoursRequired?: number;
    timeRegistration?: UserTrainingPlanUserCourseTimeRegistration;
    /**
     * 
     */
    modules?: Array<CourseModule>;
    /**
     * 
     */
    status?: PartialUserTrainingPlanUserCourse.StatusEnum;
    /**
     * 
     */
    customLocation?: string;
    /**
     * 
     */
    locationId?: string;
    /**
     * 
     */
    location?: string;
    /**
     * 
     */
    locationType?: string;
    /**
     * 
     */
    locationName?: string;
    /**
     * 
     */
    locationStreet?: string;
    /**
     * 
     */
    locationStreetNr?: string;
    /**
     * 
     */
    locationZipcode?: string;
    /**
     * 
     */
    locationCity?: string;
    /**
     * 
     */
    locationCountry?: string;
    /**
     * 
     */
    name?: string;
    /**
     * 
     */
    descr?: string;
    /**
     * 
     */
    autoAdd?: boolean;
    /**
     * 
     */
    fullAccess?: boolean;
    /**
     * 
     */
    classId?: string;
    /**
     * 
     */
    className?: string;
    /**
     * 
     */
    domains?: Array<TrainingPlanDomain>;
    /**
     * 
     */
    supervisors?: Array<UserTrainingPlanUserCourseSupervisorsInner>;
    /**
     * 
     */
    consent?: boolean;
}
export namespace PartialUserTrainingPlanUserCourse {
    export type StatusEnum = 'failed' | 'stopped' | 'passed' | 'passedWithConditions' | 'passedWithoutHours' | 'ongoing';
    export const StatusEnum = {
        Failed: 'failed' as StatusEnum,
        Stopped: 'stopped' as StatusEnum,
        Passed: 'passed' as StatusEnum,
        PassedWithConditions: 'passedWithConditions' as StatusEnum,
        PassedWithoutHours: 'passedWithoutHours' as StatusEnum,
        Ongoing: 'ongoing' as StatusEnum
    };
}


